import { render, staticRenderFns } from "./EditWorkRegistration.vue?vue&type=template&id=5a9afb0b&"
import script from "./EditWorkRegistration.vue?vue&type=script&lang=js&"
export * from "./EditWorkRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports